import { Container, Image } from "react-bootstrap";
import "../../assets/scss/components/sections/library/header.scss";
import Heading from "../../components/templates/heading";
import { useEffect, useRef, useState } from "react";
import { useDebounce } from "../../hooks/useDebounce";

import searchIcon from "../../assets/images/library/search.svg";
import CareerSelect from "./customSelects/careerSelect";
import RegionSelect from "./customSelects/regionSelect";
import IndustrySelect from "./customSelects/industrySelect";

import shape from "../../assets/images/library/shape.svg";
import inputLoader from "../../assets/images/library/input-loading-icon.svg";
import { careerList, industryList, regionList } from "./data/data";
import { autoComplete_job_titles } from "./helper";

const data = [
  { label: "Marketing sales", count: 23 },
  { label: "Market research", count: 12 },
  { label: "Market development", count: 8 },
  { label: "Market strategies", count: 5 },
];

const highlightText = (text, query) => {
  const parts = text.split(new RegExp(`(${query})`, "gi"));
  return parts.map((part, i) =>
    part.toLowerCase() === query.toLowerCase() ? (
      <mark key={i}>{part}</mark>
    ) : (
      part
    )
  );
};

const Header = ({
  onSearch,
  careerLevelChange,
  onIndustryChange,
  onRegionChange,
}) => {
  const [search, setSearch] = useState("");
  const [isTypingLoading, setIsTypingLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [hasSelectedSuggestion, setHasSelectedSuggestion] = useState(false);
  const measureRef = useRef(null);
  const iconRef = useRef(null);
  const inputRef = useRef(null);
  const [isSelectedSearchOption, setIsSelectedSearchOption] = useState("");

  const debouncedSearch = useDebounce(search, 300);

  useEffect(() => {
    const fetchSuggestions = async () => {
      if (debouncedSearch.length > 2 && !hasSelectedSuggestion) {
        setIsTypingLoading(true);
        try {
          const response = await autoComplete_job_titles(debouncedSearch);
          setSuggestions(response || []);
          setShowSuggestions(true);
        } catch (error) {
          console.error("Error fetching suggestions:", error);
          setSuggestions([]);
        } finally {
          setIsTypingLoading(false);
        }
      } else {
        setSuggestions([]);
        setShowSuggestions(false);
      }
    };

    fetchSuggestions();
  }, [debouncedSearch, hasSelectedSuggestion]);

  const handleSelectChangeIndustries = (industries) => {
    onIndustryChange(industries);
  };

  const handleSelectChange = (skill) => {
    if (careerList.includes(skill)) {
      careerLevelChange(skill);
    }
    if (regionList.includes(skill)) {
      onRegionChange(skill);
    }
  };

  const handleSearch = () => {
    onSearch(search);
    setShowSuggestions(false);
  };

  const handleSuggestionClick = (item) => {
    setSearch(item.job_title);
    setShowSuggestions(false);
    setSuggestions([]);
    setHasSelectedSuggestion(true);
    onSearch(item.job_title);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    setHasSelectedSuggestion(false);
    if (value.length > 2) {
      setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
    }
  };

  return (
    <div className="industry-header-section">
      <Container>
        <div className="header">
          <div className="content">
            <div className="heading">
              <h1 className="heading-1">World's largest Resume Library</h1>
              <p className="paragraph-small-regular">
                1M+ resume templates for{" "}
                <span className="free">
                  free <Image src={shape} className="shape" />
                </span>{" "}
                download
              </p>
            </div>
            <div className="input-container">
              <input
                type="text"
                placeholder="Job Title"
                value={search}
                // onChange={(e) => setSearch(e.target.value)}
                onChange={handleInputChange}
                ref={inputRef}
              />
              <button className={`input-button`} onClick={handleSearch}>
                <Image src={searchIcon} className="me-2" />
                Search
              </button>
              {search && isTypingLoading && (
                <span className="loading-spinner small">
                  <span ref={measureRef} className="text-measure">
                    {search}
                  </span>
                  <Image ref={iconRef} src={inputLoader} />
                </span>
              )}

              {showSuggestions && suggestions.length > 0 && (
                <ul className="dropdown">
                  {suggestions.map((item, i) => (
                    <li
                      key={i}
                      className="dropdown-item"
                      onClick={() => handleSuggestionClick(item)}
                    >
                      <span>{highlightText(item.job_title, search)}</span>
                      <span className="count">{item.count}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="filters">
              <CareerSelect
                options={careerList}
                defaultOption="All"
                onSelect={handleSelectChange}
              />
              <IndustrySelect
                options={industryList}
                defaultOption="All"
                onSelect={handleSelectChangeIndustries}
              />
              <RegionSelect
                options={regionList}
                defaultOption="North America"
                onSelect={handleSelectChange}
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Header;
